import { render, staticRenderFns } from "./change-password-modal.component.vue?vue&type=template&id=ab7160bc&scoped=true"
import script from "./change-password-modal.component.vue?vue&type=script&lang=ts"
export * from "./change-password-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./change-password-modal.component.vue?vue&type=style&index=0&id=ab7160bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7160bc",
  null
  
)

export default component.exports